<div class="popup-container tlms-popup">
	<header>
		<div class="header" style="display:block">{{heading}} Sub Task</div>
		<button class="close" style="top:-3px" (click)="close()">
			<mat-icon>close</mat-icon>
		</button>
	</header>
	<ng-container>
		<div style="padding: 16px 24px 16px 24px;">
			<div class="col-12" style="width: 100%;">
				<div class="upload">
					<div class="content-line">
						<label class="catlabel">Task ID:</label>
						<span class="content-text">
							{{ taskID }}
						</span>
					</div>
					<div class="content-line">
						<label class="catlabel">Sub Task ID:</label>
						<span class="content-subtext">
							{{ subtaskID }}
						</span>
					</div>
					<div class="content-line">
						<label class="catlabel">Description:
							<span style="color:#ff0000">*</span>
						</label>
						<span class="content">
							<input type="text" id="desc" name="desc" required minlength="4" maxlength="255" class="desc"
								[(ngModel)]="description">
						</span>
					</div>
					<div class="content-line">
						<label class="catlabel">Operating Procedure:
						</label>
						<span class="content">
							<mat-form-field appearance="outline" style="width: 242px; height: 26px;">
								<mat-select [(ngModel)]="selectedOP" [ngModelOptions]="{ standalone: true }"
									panelClass="custom-op-panel" [disableOptionCentering]="true">
									<!-- Sticky search input inside panel -->
									<div style="position: sticky; top: 0; z-index: 2; background: white; padding: 6px;">
										<ngx-mat-select-search [formControl]="opFilterControl"
											placeholderLabel="Search OP" noEntriesFoundLabel="No OP found"
											[clearSearchInput]="true" style="width: 100%;">
										</ngx-mat-select-search>
									</div>
									<!-- Filtered option list -->
									<div style="max-height: 200px; overflow-y: auto;">
										<mat-option *ngFor="let op of filteredOPDropdown | async" [value]="op">
											{{ op.label }}
										</mat-option>
									</div>
								</mat-select>
							</mat-form-field>
						</span>
					</div>
				</div>
				<label *ngIf="enableError" class="errormsg"> {{errormsg}} </label>
			</div>
		</div>
		<div class="cfooter d-flex justify-content-between align-items-center popup-footer">
			<button (click)="onNoClick()" class="mCancel"> CANCEL
			</button>
			<button class="taskm-submit" style="display: inline" (click)="saveClick()">
				SAVE
			</button>
		</div>
	</ng-container>
</div>